export default function numberOnly(value) {
    return value.replace(/\D/g, '');
}
